function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ListingDetailTemplate = require('./listing-detail.template');
var ListingFieldEdit = require('./listing-field-edit');
var returnStoreWeb3Tickers = ListingFieldEdit.returnStoreWeb3Tickers,
  requestStoreWeb3Tickers = ListingFieldEdit.requestStoreWeb3Tickers;
var Summary = require('../../summary');
var _require = require('../../summary'),
  DREAMSCAPE_PLACEHOLDER = _require.DREAMSCAPE_PLACEHOLDER;
var _require2 = require('../summary-cache'),
  summaryBucketKey = _require2.summaryBucketKey;
var _require3 = require('../../categories'),
  isStoreRentalListing = _require3.isStoreRentalListing,
  storeCategoryLabel = _require3.storeCategoryLabel;
var _require4 = require('./rental-listing.template'),
  durationLabel = _require4.durationLabel,
  rightsLabel = _require4.rightsLabel;
var _require5 = require('../purchase-service'),
  yieldForPaint = _require5.yieldForPaint;
var _require6 = require('../listing-approval'),
  isAutoSubmitListings = _require6.isAutoSubmitListings,
  markStoreWeb3Active = _require6.markStoreWeb3Active,
  scheduleSubmitAfterListingConfirmed = _require6.scheduleSubmitAfterListingConfirmed;
var ListingDetailOverlay = /*#__PURE__*/function () {
  function ListingDetailOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, ListingDetailOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.field_edit = new ListingFieldEdit(app, mod);
    this.mode = 'view';
    this.summary = null;
    this.selectedNft = null;
    this.defaults = {};
    this.preview = false;
    this.onBack = null;
    this.listing = {
      title: '',
      description: '',
      price: '1',
      quantity_total: 1,
      quantity_available: 1
    };
    this.max_quantity_total = 1;
    this.app.connection.on('store-listing-updated', function (summary) {
      var _this$overlay, _this$summary;
      if ((_this$overlay = _this.overlay) !== null && _this$overlay !== void 0 && _this$overlay.visible && _this.mode === 'view' && (_this$summary = _this.summary) !== null && _this$summary !== void 0 && _this$summary.nft_id && summaryBucketKey(_this.summary.nft_id, _this.summary.price) === summaryBucketKey(summary.nft_id, summary.price)) {
        // Paint only — do not restart archive/media loading.
        _this.render(summary);
      }
    });
  }
  return _createClass(ListingDetailOverlay, [{
    key: "escapeHtml",
    value: function escapeHtml() {
      var _this$app;
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.browser) !== null && _this$app !== void 0 && _this$app.escapeHTML) {
        return this.app.browser.escapeHTML(String(value));
      }
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  }, {
    key: "returnFallbackImage",
    value: function returnFallbackImage() {
      return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0' x2='1' y1='0' y2='1'%3E%3Cstop stop-color='%23132736'/%3E%3Cstop offset='1' stop-color='%233c8fcb'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='1200' height='800' fill='url(%23g)'/%3E%3C/svg%3E";
    }
  }, {
    key: "returnMediaHtml",
    value: function returnMediaHtml(nft) {
      if (!nft) {
        return ListingDetailTemplate.mediaImage(this.returnFallbackImage());
      }
      if (nft.image) {
        var _this$app2, _this$app2$isSafeMedi;
        if ((_this$app2 = this.app) !== null && _this$app2 !== void 0 && (_this$app2 = _this$app2.browser) !== null && _this$app2 !== void 0 && (_this$app2$isSafeMedi = _this$app2.isSafeMediaUrl) !== null && _this$app2$isSafeMedi !== void 0 && _this$app2$isSafeMedi.call(_this$app2, nft.image)) {
          return ListingDetailTemplate.mediaImage(this.escapeHtml(nft.image));
        }
        return ListingDetailTemplate.mediaImage(this.returnFallbackImage());
      }
      var textContent = nft.text || nft.json || nft.js || nft.css || nft.description || 'NFT content';
      return ListingDetailTemplate.mediaText(this.escapeHtml(textContent));
    }
  }, {
    key: "returnFileTypeFromNft",
    value: function returnFileTypeFromNft(nft) {
      var _nft$returnType;
      var type = (nft === null || nft === void 0 || (_nft$returnType = nft.returnType) === null || _nft$returnType === void 0 ? void 0 : _nft$returnType.call(nft)) || (nft === null || nft === void 0 ? void 0 : nft.nft_type) || 'unknown';
      if (type === 'image') {
        return 'image';
      }
      return type;
    }
  }, {
    key: "returnCreatedDate",
    value: function returnCreatedDate() {
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var raw = summary.created_at || summary.createdAt || summary.timestamp || Date.now();
      var date = new Date(raw);
      if (Number.isNaN(date.getTime())) {
        return new Date().toLocaleDateString();
      }
      return date.toLocaleDateString();
    }
  }, {
    key: "hasCurrencyLabel",
    value: function hasCurrencyLabel() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return /[a-zA-Z]/.test(String(value));
    }
  }, {
    key: "formatSaitoPriceDisplay",
    value: function formatSaitoPriceDisplay(value) {
      var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SAITO';
      var raw = String(value !== null && value !== void 0 ? value : '').trim();
      if (!raw || raw === 'N/A') {
        return raw === 'N/A' ? 'N/A' : '';
      }
      var numeric = raw.replace(/SAITO/gi, '').replace(/,/g, '').trim();
      if (!numeric || !Number.isFinite(Number(numeric))) {
        return this.hasCurrencyLabel(raw) ? raw : "".concat(raw, " ").concat(currency);
      }
      var formatted = Number(numeric).toLocaleString('en-US', {
        maximumFractionDigits: 8
      });
      return "".concat(formatted, " ").concat(currency);
    }
  }, {
    key: "returnProductType",
    value: function returnProductType() {
      var _summary$nft, _summary$nft2;
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nft_type = (typeof (summary === null || summary === void 0 || (_summary$nft = summary.nft) === null || _summary$nft === void 0 ? void 0 : _summary$nft.returnType) === 'function' ? summary.nft.returnType() : '') || (summary === null || summary === void 0 || (_summary$nft2 = summary.nft) === null || _summary$nft2 === void 0 ? void 0 : _summary$nft2.nft_type) || (summary === null || summary === void 0 ? void 0 : summary.type) || '';
      return storeCategoryLabel(summary.category, nft_type);
    }
  }, {
    key: "returnListingMeta",
    value: function returnListingMeta() {
      var _tx$returnMessage;
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var tx = summary.listing_tx;
      var txmsg = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
      return txmsg.listing || {};
    }
  }, {
    key: "returnSellerDisplay",
    value: function returnSellerDisplay() {
      var _this$app3, _this$app3$returnIden;
      var seller = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var key = String(seller || '').trim();
      if (!key) {
        return {
          text: 'anon-store',
          isKey: false
        };
      }
      var identifier = ((_this$app3 = this.app) === null || _this$app3 === void 0 || (_this$app3 = _this$app3.keychain) === null || _this$app3 === void 0 || (_this$app3$returnIden = _this$app3.returnIdentifierByPublicKey) === null || _this$app3$returnIden === void 0 ? void 0 : _this$app3$returnIden.call(_this$app3, key)) || '';
      if (identifier && identifier !== key) {
        return {
          text: identifier,
          isKey: false
        };
      }
      return {
        text: key,
        isKey: true
      };
    }
  }, {
    key: "returnViewModel",
    value: function returnViewModel() {
      var _summary$returnTitle,
        _summary$returnSeller,
        _summary$nft3,
        _summary$nft4,
        _summary$returnMediaD,
        _summary$hasLoadedIma,
        _summary$returnImage,
        _summary$returnPlaceh,
        _this2 = this,
        _summary$returnPrice,
        _summary$returnQuanti,
        _summary$returnDescri,
        _summary$nft5,
        _summary$nft6,
        _this$app4,
        _this$app4$returnIden,
        _summary$isImageLoadi,
        _summary$isImageLoadi2;
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var listingTitle = this.escapeHtml(((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || 'Untitled Item');
      var sellerKey = ((_summary$returnSeller = summary.returnSeller) === null || _summary$returnSeller === void 0 ? void 0 : _summary$returnSeller.call(summary)) || summary.seller || '';
      var sellerDisplay = this.returnSellerDisplay(sellerKey);
      var nftId = String(summary.nft_id || ((_summary$nft3 = summary.nft) === null || _summary$nft3 === void 0 ? void 0 : _summary$nft3.id) || ((_summary$nft4 = summary.nft) === null || _summary$nft4 === void 0 ? void 0 : _summary$nft4.uuid) || '').trim();
      var display = ((_summary$returnMediaD = summary.returnMediaDisplay) === null || _summary$returnMediaD === void 0 ? void 0 : _summary$returnMediaD.call(summary)) || {};
      var listingImage = display.backgroundImage || ((_summary$hasLoadedIma = summary.hasLoadedImage) !== null && _summary$hasLoadedIma !== void 0 && _summary$hasLoadedIma.call(summary) ? ((_summary$returnImage = summary.returnImage) === null || _summary$returnImage === void 0 ? void 0 : _summary$returnImage.call(summary)) || '' : '');
      var placeholder = display.loading || display.innerHtml ? '' : ((_summary$returnPlaceh = summary.returnPlaceholderImage) === null || _summary$returnPlaceh === void 0 ? void 0 : _summary$returnPlaceh.call(summary)) || DREAMSCAPE_PLACEHOLDER;
      var rawImages = Array.isArray(summary.images) ? summary.images.filter(Boolean) : [listingImage || placeholder];
      var normalizedImages = rawImages.filter(function (src) {
        var _this2$app, _this2$app$isSafeMedi;
        return (_this2$app = _this2.app) === null || _this2$app === void 0 || (_this2$app = _this2$app.browser) === null || _this2$app === void 0 || (_this2$app$isSafeMedi = _this2$app.isSafeMediaUrl) === null || _this2$app$isSafeMedi === void 0 ? void 0 : _this2$app$isSafeMedi.call(_this2$app, src);
      }).map(function (src) {
        return _this2.escapeHtml(src);
      });
      if (!normalizedImages.length) {
        normalizedImages.push(this.escapeHtml(DREAMSCAPE_PLACEHOLDER));
      }
      var listingMeta = this.returnListingMeta(summary);
      var isRental = isStoreRentalListing(summary, listingMeta);
      var priceValue = ((_summary$returnPrice = summary.returnPrice) === null || _summary$returnPrice === void 0 ? void 0 : _summary$returnPrice.call(summary)) || summary.price || summary.reserve_price || '';
      var bidValue = summary.current_bid || summary.currentBid || '';
      var isBid = !!bidValue && !priceValue && !isRental;
      var primaryValue = isBid ? bidValue : priceValue || 'N/A';
      var primaryLabel = isRental ? 'Rental Price' : isBid ? 'Current Bid' : 'Price';
      var currency = summary.currency || summary.denomination || 'SAITO';
      var nextBid = summary.next_bid || summary.nextMinBid || '';
      var supply = ((_summary$returnQuanti = summary.returnQuantity) === null || _summary$returnQuanti === void 0 ? void 0 : _summary$returnQuanti.call(summary)) || 1;
      var actionText = isRental ? 'Rent' : isBid ? 'Bid' : 'Buy';
      var description = this.escapeHtml(((_summary$returnDescri = summary.returnDescription) === null || _summary$returnDescri === void 0 ? void 0 : _summary$returnDescri.call(summary)) || '');
      var primaryDisplay = this.escapeHtml(this.formatSaitoPriceDisplay(primaryValue, currency));
      var nextBidDisplay = this.escapeHtml(this.formatSaitoPriceDisplay(nextBid, currency));
      var durationHours = listingMeta.rental_duration_hours || ((_summary$nft5 = summary.nft) === null || _summary$nft5 === void 0 || (_summary$nft5 = _summary$nft5.data) === null || _summary$nft5 === void 0 ? void 0 : _summary$nft5.duration_hours);
      var rights = listingMeta.rental_rights || ((_summary$nft6 = summary.nft) === null || _summary$nft6 === void 0 || (_summary$nft6 = _summary$nft6.data) === null || _summary$nft6 === void 0 ? void 0 : _summary$nft6.rights) || 'all';
      return {
        identicon: this.escapeHtml(((_this$app4 = this.app) === null || _this$app4 === void 0 || (_this$app4 = _this$app4.keychain) === null || _this$app4 === void 0 || (_this$app4$returnIden = _this$app4.returnIdenticon) === null || _this$app4$returnIden === void 0 ? void 0 : _this$app4$returnIden.call(_this$app4, nftId || sellerKey)) || ''),
        listingTitle: listingTitle,
        nftId: this.escapeHtml(nftId),
        nftIdDisplay: this.escapeHtml(nftId || '—'),
        seller: this.escapeHtml(sellerDisplay.text),
        sellerIsKey: sellerDisplay.isKey,
        images: normalizedImages,
        hasGallery: normalizedImages.length > 1,
        primaryLabel: this.escapeHtml(primaryLabel),
        primaryDisplay: primaryDisplay,
        canShare: !!sellerKey && !!nftId,
        nextBid: nextBid,
        showNextBid: !!nextBid && !isRental,
        nextBidDisplay: nextBidDisplay,
        supply: supply,
        showQuantity: !isRental && supply > 1,
        actionText: this.escapeHtml(actionText),
        description: description,
        hasDescription: !!description,
        productType: this.escapeHtml(this.returnProductType(summary)),
        createdDate: this.escapeHtml(this.returnCreatedDate(summary)),
        imageLoading: (_summary$isImageLoadi = (_summary$isImageLoadi2 = summary.isImageLoading) === null || _summary$isImageLoadi2 === void 0 ? void 0 : _summary$isImageLoadi2.call(summary)) !== null && _summary$isImageLoadi !== void 0 ? _summary$isImageLoadi : false,
        isRental: isRental,
        rentalDuration: this.escapeHtml(durationHours ? durationLabel(durationHours) : ''),
        rentalRights: this.escapeHtml(rightsLabel(rights))
      };
    }
  }, {
    key: "returnEditView",
    value: function returnEditView(nft) {
      var _nft$slip, _nft$slip2, _this$app5, _this$app5$returnIden, _nft$returnType2;
      var seller = this.mod.publicKey || 'anon-store';
      var priceNum = Number(this.listing.price) || 1;
      var creator = (typeof (nft === null || nft === void 0 ? void 0 : nft.returnCreator) === 'function' ? nft.returnCreator() : null) || (nft === null || nft === void 0 ? void 0 : nft.creator) || (nft === null || nft === void 0 || (_nft$slip = nft.slip1) === null || _nft$slip === void 0 ? void 0 : _nft$slip.publicKey) || (nft === null || nft === void 0 || (_nft$slip2 = nft.slip1) === null || _nft$slip2 === void 0 ? void 0 : _nft$slip2.public_key) || '';
      var nftId = (nft === null || nft === void 0 ? void 0 : nft.id) || (nft === null || nft === void 0 ? void 0 : nft.uuid) || '';
      var nftIdenticon = ((_this$app5 = this.app) === null || _this$app5 === void 0 || (_this$app5 = _this$app5.keychain) === null || _this$app5 === void 0 || (_this$app5$returnIden = _this$app5.returnIdenticon) === null || _this$app5$returnIden === void 0 ? void 0 : _this$app5$returnIden.call(_this$app5, nftId || creator || seller)) || '';
      return {
        listingTitle: this.escapeHtml(this.listing.title),
        seller: this.escapeHtml(seller),
        creatorDisplay: this.escapeHtml(creator || 'Unknown creator'),
        nftIdenticon: nftIdenticon,
        mediaHtml: this.returnMediaHtml(nft),
        description: this.escapeHtml(this.listing.description),
        priceDisplay: this.formatSaitoPriceDisplay(this.listing.price, this.listing.web3_ticker || 'SAITO'),
        productType: this.escapeHtml((nft === null || nft === void 0 || (_nft$returnType2 = nft.returnType) === null || _nft$returnType2 === void 0 ? void 0 : _nft$returnType2.call(nft)) || 'NFT'),
        fileType: this.escapeHtml(this.returnFileTypeFromNft(nft)),
        createdDate: new Date().toLocaleDateString(),
        supply: this.listing.quantity_total
      };
    }
  }, {
    key: "resetListingFromNft",
    value: function resetListingFromNft(nft) {
      var _nft$getTotalAmount;
      var max_quantity_total = Number((nft === null || nft === void 0 || (_nft$getTotalAmount = nft.getTotalAmount) === null || _nft$getTotalAmount === void 0 ? void 0 : _nft$getTotalAmount.call(nft)) || (nft === null || nft === void 0 ? void 0 : nft.amount) || 1) || 1;
      this.max_quantity_total = max_quantity_total;
      this.listing = {
        title: (nft === null || nft === void 0 ? void 0 : nft.title) || 'Untitled NFT',
        description: (nft === null || nft === void 0 ? void 0 : nft.description) || '',
        price: '1',
        web3_ticker: 'SAITO',
        web3_amount: '1',
        quantity_total: max_quantity_total,
        quantity_available: max_quantity_total
      };
    }
  }, {
    key: "applyProductMedia",
    value: function applyProductMedia() {
      var _summary$returnMediaD2;
      var summary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.summary;
      if (!(summary instanceof Summary)) {
        return;
      }
      var display = ((_summary$returnMediaD2 = summary.returnMediaDisplay) === null || _summary$returnMediaD2 === void 0 ? void 0 : _summary$returnMediaD2.call(summary)) || {};
      var media = document.querySelector('.listing-detail .media');
      var mainImage = document.querySelector('.listing-detail .image');
      if (!media) {
        return;
      }
      var content = media.querySelector('.media-content');
      if (display.loading) {
        return;
      }
      if (display.innerHtml) {
        if (mainImage) {
          mainImage.style.display = 'none';
        }
        if (!content) {
          content = document.createElement('div');
          content.className = 'media-content';
          media.appendChild(content);
        }
        content.innerHTML = display.innerHtml;
        return;
      }
      if (content) {
        content.remove();
      }
      if (mainImage) {
        var _this$app6, _this$app6$isSafeMedi;
        mainImage.style.display = '';
        if (display.backgroundImage && (_this$app6 = this.app) !== null && _this$app6 !== void 0 && (_this$app6 = _this$app6.browser) !== null && _this$app6 !== void 0 && (_this$app6$isSafeMedi = _this$app6.isSafeMediaUrl) !== null && _this$app6$isSafeMedi !== void 0 && _this$app6$isSafeMedi.call(_this$app6, display.backgroundImage)) {
          mainImage.setAttribute('src', display.backgroundImage);
        }
      }
    }

    /**
     * Open a listing for viewing: paint immediately, then load anything missing.
     * Callers that only need a repaint (media updates, etc.) should use render().
     * preview: hide purchase controls (moderation inspect).
     */
  }, {
    key: "open",
    value: function open(summary) {
      var _this3 = this,
        _summary$isImageLoadi4;
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$preview = _ref.preview,
        preview = _ref$preview === void 0 ? false : _ref$preview;
      this.preview = !!preview;
      this.render(summary);
      if (!(summary instanceof Summary)) {
        return;
      }
      var finish = function finish() {
        var _this3$overlay;
        if ((_this3$overlay = _this3.overlay) !== null && _this3$overlay !== void 0 && _this3$overlay.visible && _this3.mode === 'view' && _this3.summary === summary) {
          _this3.render(summary);
        }
      };
      if (!summary.listing_tx && summary.listing_signature) {
        summary.ensureListingTransaction(function () {
          var _summary$isImageLoadi3;
          if ((_summary$isImageLoadi3 = summary.isImageLoading) !== null && _summary$isImageLoadi3 !== void 0 && _summary$isImageLoadi3.call(summary)) {
            summary.enrichMedia(finish);
            return;
          }
          finish();
        });
        return;
      }
      if ((_summary$isImageLoadi4 = summary.isImageLoading) !== null && _summary$isImageLoadi4 !== void 0 && _summary$isImageLoadi4.call(summary)) {
        summary.enrichMedia(finish);
      }
    }

    /**
     * Paint the overlay from current state. Does not load or enrich data.
     * View: render(summary) | Edit: render({ mode: 'edit', nft, defaults })
     */
  }, {
    key: "render",
    value: function render() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (input && !(input instanceof Summary) && input.mode === 'edit') {
        this.renderEdit(input.nft, input.defaults || {});
        return;
      }
      this.mode = 'view';
      if (input) {
        this.summary = input;
      }
      var view = this.returnViewModel(this.summary || {});
      this.overlay.show(ListingDetailTemplate.viewTemplate(view));
      this.attachViewEvents();
      this.applyProductMedia();
    }
  }, {
    key: "renderEdit",
    value: function renderEdit(nft) {
      var _this4 = this;
      var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.mode = 'edit';
      this.listing_busy = false;
      this.defaults = defaults;
      this.selectedNft = (nft === null || nft === void 0 ? void 0 : nft.nft) || nft;
      this.resetListingFromNft(this.selectedNft);
      var view = this.returnEditView(this.selectedNft);
      this.overlay.show(ListingDetailTemplate.editTemplate(view), function () {
        var _this4$defaults;
        if (typeof ((_this4$defaults = _this4.defaults) === null || _this4$defaults === void 0 ? void 0 : _this4$defaults.callback) === 'function') {
          _this4.defaults.callback({
            status: 'cancelled'
          });
        }
      });
      this.attachEditEvents();
      this.applyEditDefaults();
    }
  }, {
    key: "attachViewEvents",
    value: function attachViewEvents() {
      var _this5 = this;
      var root = document.querySelector('.listing-detail');
      if (!root) {
        return;
      }
      var mainImage = root.querySelector('.image');
      root.querySelectorAll('.thumb').forEach(function (thumb) {
        thumb.onclick = function (e) {
          e.preventDefault();
          var src = thumb.getAttribute('data-src');
          if (mainImage && src) {
            mainImage.setAttribute('src', src);
          }
          root.querySelectorAll('.thumb').forEach(function (n) {
            n.classList.remove('active');
            n.setAttribute('aria-pressed', 'false');
          });
          thumb.classList.add('active');
          thumb.setAttribute('aria-pressed', 'true');
        };
      });
      if (mainImage) {
        mainImage.onerror = function () {
          var _summary$returnMediaD3;
          var summary = _this5.summary;
          var display = (summary === null || summary === void 0 || (_summary$returnMediaD3 = summary.returnMediaDisplay) === null || _summary$returnMediaD3 === void 0 ? void 0 : _summary$returnMediaD3.call(summary)) || {};
          if (display.innerHtml || display.loading) {
            return;
          }
          mainImage.onerror = null;
          if (!(summary instanceof Summary)) {
            return;
          }
          summary.enrichMedia(function () {
            var _this5$overlay;
            if ((_this5$overlay = _this5.overlay) !== null && _this5$overlay !== void 0 && _this5$overlay.visible && _this5.mode === 'view' && _this5.summary === summary) {
              _this5.render(summary);
            }
          });
        };
      }
      var shareBtn = root.querySelector('[data-action="share"]');
      if (shareBtn) {
        shareBtn.onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var summary, longUrl, url, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                summary = _this5.summary;
                longUrl = "".concat(window.location.origin, "/").concat(_this5.mod.slug, "/").concat(encodeURIComponent(summary.returnSeller()), "/").concat(encodeURIComponent(summary.nft_id));
                shareBtn.disabled = true;
                url = longUrl;
                _context.p = 1;
                _context.n = 2;
                return _this5.mod.createShortLink(longUrl);
              case 2:
                url = _context.v;
                _context.n = 4;
                break;
              case 3:
                _context.p = 3;
                _t = _context.v;
                console.warn('Store: short link unavailable', _t);
              case 4:
                _context.p = 4;
                shareBtn.disabled = false;
                return _context.f(4);
              case 5:
                _this5.app.browser.handleShare({
                  title: summary.returnTitle(),
                  url: url
                });
              case 6:
                return _context.a(2);
            }
          }, _callee, null, [[1, 3, 4, 5]]);
        }));
      }
      var buyBtn = root.querySelector('[data-action="buy"]');
      if (this.preview) {
        var checkout = root.querySelector('.checkout');
        if (checkout) {
          checkout.hidden = true;
        }
        if (buyBtn) {
          buyBtn.disabled = true;
        }
        return;
      }
      if (buyBtn) {
        buyBtn.onclick = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var _this5$mod$main;
            var summary, listingMeta, isRental, qtyInput, quantity, noteEl, note, ticker, web3Payment, _this5$mod$main2;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  e.preventDefault();
                  summary = _this5.summary;
                  if (summary instanceof Summary) {
                    _context2.n = 1;
                    break;
                  }
                  return _context2.a(2);
                case 1:
                  listingMeta = _this5.returnListingMeta(summary);
                  isRental = isStoreRentalListing(summary, listingMeta);
                  qtyInput = root.querySelector('#listing-qty');
                  quantity = isRental ? 1 : qtyInput ? Number(qtyInput.value) || 1 : 1;
                  noteEl = root.querySelector('#listing-note');
                  note = noteEl ? String(noteEl.value || '').trim() : '';
                  if (!buyBtn.disabled) {
                    _context2.n = 2;
                    break;
                  }
                  return _context2.a(2);
                case 2:
                  buyBtn.disabled = true;
                  ticker = String(summary.web3_ticker || '').trim().toUpperCase();
                  web3Payment = (_this5$mod$main = _this5.mod.main) === null || _this5$mod$main === void 0 ? void 0 : _this5$mod$main.web3_payment;
                  _context2.p = 3;
                  if (!(ticker && ticker !== 'SAITO' && web3Payment !== null && web3Payment !== void 0 && web3Payment.isWeb3Summary(summary))) {
                    _context2.n = 5;
                    break;
                  }
                  _context2.n = 4;
                  return web3Payment.start(summary, quantity, {
                    note: note
                  });
                case 4:
                  return _context2.a(2);
                case 5:
                  _context2.n = 6;
                  return (_this5$mod$main2 = _this5.mod.main) === null || _this5$mod$main2 === void 0 || (_this5$mod$main2 = _this5$mod$main2.purchase_flow) === null || _this5$mod$main2 === void 0 ? void 0 : _this5$mod$main2.startPurchase(summary, quantity, {
                    note: note
                  });
                case 6:
                  _context2.p = 6;
                  buyBtn.disabled = false;
                  return _context2.f(6);
                case 7:
                  return _context2.a(2);
              }
            }, _callee2, null, [[3,, 6, 7]]);
          }));
          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "attachEditEvents",
    value: function attachEditEvents() {
      var _this6 = this,
        _root$querySelector,
        _root$querySelector2,
        _root$querySelector3,
        _root$querySelector4;
      var root = document.querySelector('.listing-detail.edit:not(.rental-ready)');
      if (!root) {
        return;
      }
      var openFieldEdit = function openFieldEdit(field) {
        var _this6$defaults;
        if ((_this6$defaults = _this6.defaults) !== null && _this6$defaults !== void 0 && (_this6$defaults = _this6$defaults.locked) !== null && _this6$defaults !== void 0 && _this6$defaults.includes(field.lockKey || field.name)) {
          return;
        }
        _this6.field_edit.render({
          title: field.title,
          value: field.value,
          multiline: !!field.multiline,
          inputType: field.inputType || 'text',
          placeholder: field.placeholder || '',
          onSave: function onSave(raw) {
            var result = field.parse(raw);
            if (result === false) {
              return false;
            }
            field.apply(result);
            return true;
          }
        });
      };
      (_root$querySelector = root.querySelector('[data-edit="title"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        openFieldEdit({
          name: 'title',
          title: 'Edit Title',
          value: _this6.listing.title,
          placeholder: 'Listing title',
          parse: function parse(raw) {
            var next = String(raw || '').trim();
            return next || false;
          },
          apply: function apply(next) {
            _this6.listing.title = next;
            root.querySelector('[data-field="title"]').textContent = next;
          }
        });
      });
      (_root$querySelector2 = root.querySelector('[data-edit="description"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', function (e) {
        e.preventDefault();
        openFieldEdit({
          name: 'description',
          lockKey: 'description',
          title: 'Edit Description',
          value: _this6.listing.description,
          multiline: true,
          placeholder: 'Describe this listing',
          parse: function parse(raw) {
            return String(raw !== null && raw !== void 0 ? raw : '').trim();
          },
          apply: function apply(next) {
            _this6.listing.description = next;
            root.querySelector('[data-field="description"]').textContent = next || 'No description provided.';
          }
        });
      });
      (_root$querySelector3 = root.querySelector('[data-edit="price"]')) === null || _root$querySelector3 === void 0 || _root$querySelector3.addEventListener('click', function (e) {
        var _this6$defaults2;
        e.preventDefault();
        if ((_this6$defaults2 = _this6.defaults) !== null && _this6$defaults2 !== void 0 && (_this6$defaults2 = _this6$defaults2.locked) !== null && _this6$defaults2 !== void 0 && _this6$defaults2.includes('price')) {
          return;
        }
        requestStoreWeb3Tickers(_this6.app);
        var ticker = String(_this6.listing.web3_ticker || 'SAITO').trim().toUpperCase() || 'SAITO';
        _this6.field_edit.render({
          title: 'Edit Price',
          value: String(_this6.listing.price),
          inputType: 'text',
          placeholder: 'Price',
          tickers: returnStoreWeb3Tickers(_this6.app, ticker),
          ticker: ticker,
          onSave: function onSave(raw, selectedTicker) {
            var cleaned = String(raw || '').trim().replace(/[^\d.]/g, '');
            if (!cleaned) {
              return false;
            }
            var nextTicker = String(selectedTicker || 'SAITO').trim().toUpperCase() || 'SAITO';
            _this6.listing.price = cleaned;
            _this6.listing.web3_ticker = nextTicker;
            _this6.listing.web3_amount = cleaned;
            var priceEl = root.querySelector('[data-field="price"]');
            if (priceEl) {
              priceEl.textContent = _this6.formatSaitoPriceDisplay(cleaned, nextTicker);
            }
            return true;
          }
        });
        var input = document.getElementById('saito-overlay-form-input');
        if (input) {
          input.setAttribute('inputmode', 'decimal');
          input.addEventListener('beforeinput', function (ev) {
            var _input$selectionStart, _input$selectionEnd;
            if (!ev.data || !String(ev.inputType || '').startsWith('insert')) {
              return;
            }
            if (/[^\d.]/.test(ev.data)) {
              ev.preventDefault();
              return;
            }
            var start = (_input$selectionStart = input.selectionStart) !== null && _input$selectionStart !== void 0 ? _input$selectionStart : input.value.length;
            var end = (_input$selectionEnd = input.selectionEnd) !== null && _input$selectionEnd !== void 0 ? _input$selectionEnd : start;
            var next = input.value.slice(0, start) + ev.data + input.value.slice(end);
            var dot = next.indexOf('.');
            if (dot !== -1 && next.slice(dot + 1).includes('.')) {
              ev.preventDefault();
            }
          });
          input.addEventListener('input', function () {
            var prev = input.value;
            var cleaned = prev.replace(/[^\d.]/g, '');
            var dot = cleaned.indexOf('.');
            if (dot !== -1) {
              cleaned = cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, '');
            }
            if (cleaned === prev) {
              return;
            }
            var pos = input.selectionStart;
            input.value = cleaned;
            if (typeof pos === 'number') {
              var nextPos = Math.max(0, pos - (prev.length - cleaned.length));
              input.setSelectionRange(nextPos, nextPos);
            }
          });
        }
      });
      (_root$querySelector4 = root.querySelector('[data-edit="available"]')) === null || _root$querySelector4 === void 0 || _root$querySelector4.addEventListener('click', function (e) {
        e.preventDefault();
        openFieldEdit({
          name: 'available',
          lockKey: 'quantity',
          title: 'Edit Available Quantity',
          value: String(_this6.listing.quantity_total),
          inputType: 'number',
          placeholder: "1\u2013".concat(_this6.max_quantity_total),
          parse: function parse(raw) {
            var qty = parseInt(String(raw || '').trim(), 10);
            if (!Number.isFinite(qty) || qty < 1) {
              return false;
            }
            if (qty > _this6.max_quantity_total) {
              qty = _this6.max_quantity_total;
            }
            return qty;
          },
          apply: function apply(qty) {
            _this6.listing.quantity_total = qty;
            _this6.listing.quantity_available = qty;
            root.querySelector('[data-field="available"]').textContent = String(qty);
          }
        });
      });
      var submitBtn = root.querySelector('[data-action="submit"]');
      if (submitBtn) {
        submitBtn.onclick = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  e.preventDefault();
                  _context3.n = 1;
                  return _this6.submitListing();
                case 1:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref4.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "applyEditDefaults",
    value: function applyEditDefaults() {
      var _this$defaults, _this$defaults2, _this$defaults3;
      var root = document.querySelector('.listing-detail.edit');
      if (!root) {
        return;
      }
      if ((_this$defaults = this.defaults) !== null && _this$defaults !== void 0 && _this$defaults.price) {
        var _this$defaults$locked;
        this.listing.price = String(this.defaults.price);
        this.listing.web3_amount = String(this.defaults.price);
        var priceEl = root.querySelector('[data-field="price"]');
        if (priceEl) {
          priceEl.textContent = this.formatSaitoPriceDisplay(this.listing.price, this.listing.web3_ticker || 'SAITO');
        }
        if ((_this$defaults$locked = this.defaults.locked) !== null && _this$defaults$locked !== void 0 && _this$defaults$locked.includes('price')) {
          var affordance = root.querySelector('[data-edit="price"]');
          if (affordance) {
            affordance.hidden = true;
          }
        }
      }
      if ((_this$defaults2 = this.defaults) !== null && _this$defaults2 !== void 0 && _this$defaults2.quantity) {
        var _this$defaults$locked2;
        var qty = parseInt(this.defaults.quantity, 10);
        if (!Number.isFinite(qty) || qty < 1) {
          qty = 1;
        }
        if (qty > this.max_quantity_total) {
          qty = this.max_quantity_total;
        }
        this.listing.quantity_total = qty;
        this.listing.quantity_available = qty;
        var qtyEl = root.querySelector('[data-field="available"]');
        if (qtyEl) {
          qtyEl.textContent = String(qty);
        }
        if ((_this$defaults$locked2 = this.defaults.locked) !== null && _this$defaults$locked2 !== void 0 && _this$defaults$locked2.includes('quantity')) {
          var _affordance = root.querySelector('[data-edit="available"]');
          if (_affordance) {
            _affordance.hidden = true;
          }
        }
      }
      if ((_this$defaults3 = this.defaults) !== null && _this$defaults3 !== void 0 && _this$defaults3.description) {
        var _this$defaults$locked3;
        this.listing.description = String(this.defaults.description);
        var descEl = root.querySelector('[data-field="description"]');
        if (descEl) {
          descEl.textContent = this.listing.description || 'No description provided';
        }
        if ((_this$defaults$locked3 = this.defaults.locked) !== null && _this$defaults$locked3 !== void 0 && _this$defaults$locked3.includes('description')) {
          var _affordance2 = root.querySelector('[data-edit="description"]');
          if (_affordance2) {
            _affordance2.hidden = true;
          }
        }
      }
    }
  }, {
    key: "submitListing",
    value: function () {
      var _submitListing = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this7 = this;
        var root, submitBtn, restore, _this$defaults4, ticker, tx, _this$mod$main, _this$mod$main$render, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!this.listing_busy) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              root = document.querySelector('.listing-detail.edit:not(.rental-ready)');
              submitBtn = root === null || root === void 0 ? void 0 : root.querySelector('[data-action="submit"]');
              if (!(submitBtn !== null && submitBtn !== void 0 && submitBtn.disabled)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              restore = function restore() {
                _this7.listing_busy = false;
                if (!submitBtn) {
                  return;
                }
                submitBtn.disabled = false;
                submitBtn.removeAttribute('aria-busy');
                submitBtn.textContent = 'Submit Listing';
              };
              this.listing_busy = true;
              if (!(this.overlay && this.overlay.visible === false)) {
                _context4.n = 3;
                break;
              }
              restore();
              return _context4.a(2);
            case 3:
              if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.setAttribute('aria-busy', 'true');
                submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Preparing listing…';
              }
              _context4.n = 4;
              return yieldForPaint();
            case 4:
              _context4.p = 4;
              ticker = String(this.listing.web3_ticker || 'SAITO').trim().toUpperCase() || 'SAITO';
              this.listing.web3_ticker = ticker;
              this.listing.web3_amount = String(this.listing.price || '').trim();
              _context4.n = 5;
              return this.mod.createListAssetTransaction(this.selectedNft, this.listing);
            case 5:
              tx = _context4.v;
              _context4.n = 6;
              return this.app.network.propagateTransaction(tx);
            case 6:
              if (ticker !== 'SAITO' && markStoreWeb3Active(this.app)) {
                (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || (_this$mod$main = _this$mod$main.menu) === null || _this$mod$main === void 0 || (_this$mod$main$render = _this$mod$main.render) === null || _this$mod$main$render === void 0 || _this$mod$main$render.call(_this$mod$main);
              }
              if (typeof ((_this$defaults4 = this.defaults) === null || _this$defaults4 === void 0 ? void 0 : _this$defaults4.callback) === 'function') {
                this.defaults.callback({
                  status: 'listed',
                  tx: tx
                });
                this.defaults.callback = null;
              }
              this.beginListingProgress(tx);
              if (isAutoSubmitListings(this.app)) {
                scheduleSubmitAfterListingConfirmed(this.app, this.mod, tx.signature);
              }
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t2 = _context4.v;
              console.error('Store: listing failed', _t2);
              restore();
              alert((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Listing failed');
            case 8:
              return _context4.a(2);
          }
        }, _callee4, this, [[4, 7]]);
      }));
      function submitListing() {
        return _submitListing.apply(this, arguments);
      }
      return submitListing;
    }()
  }, {
    key: "beginListingProgress",
    value: function beginListingProgress(tx) {
      var _this$listing,
        _this8 = this,
        _this$mod$main2;
      if (!this.mod.listing_lifecycle) {
        var ListingLifecycle = require('../listing-lifecycle');
        this.mod.listing_lifecycle = new ListingLifecycle(this.app, this.mod);
      }
      var entry = this.mod.listing_lifecycle.begin({
        nft: this.selectedNft,
        listing: this.listing,
        listingTx: tx,
        sellerPublicKey: this.mod.publicKey
      });

      // Close create-listing UI without treating it as cancel.
      this.overlay.close();
      var title = (entry === null || entry === void 0 ? void 0 : entry.title) || ((_this$listing = this.listing) === null || _this$listing === void 0 ? void 0 : _this$listing.title) || '';
      var safeTitle = String(title).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      var lead = safeTitle ? "Your listing for <strong>".concat(safeTitle, "</strong> has been broadcast to the Saito network.") : 'Your listing has been broadcast to the Saito network.';

      // Progress overlay first so the user never sees a silent close.
      this.mod.transaction_monitor.render({
        tx: tx,
        title: 'Listing Submitted',
        lead: lead,
        subtitle: '',
        successTitle: 'Listing Successful',
        successLead: 'You have successfully added an item to your Saito Store.',
        callback: function callback(result) {
          if ((result === null || result === void 0 ? void 0 : result.status) === 'cancelled') {
            var _this8$mod$listing_li, _this8$mod$listing_li2;
            var active = (_this8$mod$listing_li = _this8.mod.listing_lifecycle) === null || _this8$mod$listing_li === void 0 || (_this8$mod$listing_li2 = _this8$mod$listing_li.returnActiveListing) === null || _this8$mod$listing_li2 === void 0 ? void 0 : _this8$mod$listing_li2.call(_this8$mod$listing_li);
            if (active) {
              _this8.mod.listing_lifecycle.dismiss(active.id);
            }
          }
        }
      });

      // Switch Store underneath to the seller admin page (when the Store page is active).
      if ((_this$mod$main2 = this.mod.main) !== null && _this$mod$main2 !== void 0 && _this$mod$main2.openStorefront && this.mod.publicKey) {
        Promise.resolve(this.mod.main.openStorefront(this.mod.publicKey, {
          celebrate: true,
          admin: true
        }))["catch"](function (err) {
          console.warn('Store: openStorefront after list failed', (err === null || err === void 0 ? void 0 : err.message) || err);
        });
      }
    }
  }]);
}();
module.exports = ListingDetailOverlay;